module.exports = __webpack_public_path__ + "img/icon-form.eaeef6dc.png";